import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import "../../../src/index.css"
function ProjectCards(props) {
  const images = Array.isArray(props.imgPath) ? props.imgPath : [props.imgPath];

  return (
    <Card className="project-card-view">
      <div className="project-card-images">
        {images.map((img, index) => (
          <Card.Img
            key={index}
            variant="top"
            src={img}
            alt={`project-img-${index}`}
            className="project-image"
          />
        ))}
      </div>

      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>

        <Button variant="primary" href={props.ghLink} target="_blank">
          <BsGithub /> &nbsp;
          {props.isBlog ? "Blog" : "GitHub"}
        </Button>

        {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <CgWebsite /> &nbsp;
            Demo
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
